import ProductDealerSelect from '@/vendor/Product/ProductDealerSelect.js';

class PriceCalculator {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-product-price-calculator="scope"]',
			surfaceInput: '[data-product-price-calculator="surface"]',
			submitButton: '[data-product-price-calculator="submit"]',
			hint: '[data-product-price-calculator="hint"]',
			result: '[data-product-price-calculator="result"]',
			price: '[data-product-price-calculator="price"]',
			dealerScope: '[data-product-dealer-select="scope"]',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.pricePerSurface = parseFloat(this.$scope.data('price')) || 0;
		this.dealerSelect = null;

		this.$scope
			.on('input', this.config.surfaceInput, this.handleInput.bind(this))
			.on('click', this.config.submitButton, this.handleSubmit.bind(this));
	}

	handleInput(event) {
		let hasValue = this.getSurface(event.currentTarget) !== null;

		this.$scope.find(this.config.submitButton).prop('hidden', !hasValue);
		this.$scope.find(this.config.hint).prop('hidden', hasValue);
	}

	handleSubmit(event) {
		event.preventDefault();

		let surface = this.getSurface(this.$scope.find(this.config.surfaceInput));
		if (surface === null) {
			return;
		}

		this.$scope.find(this.config.price).text(this.formatPrice(surface * this.pricePerSurface));
		this.$scope.find(this.config.result).prop('hidden', false);

		// Pas instantiëren bij de eerste berekening: zo vraagt de dealer-widget niet
		// meteen bij binnenkomst al om locatietoestemming, maar pas na een bewuste actie.
		if (!this.dealerSelect) {
			this.dealerSelect = new ProductDealerSelect({scope: this.config.dealerScope});
		}
	}

	getSurface(input) {
		let value = parseFloat($(input).val());

		return !isNaN(value) && value > 0 ? value : null;
	}

	formatPrice(value) {
		return value.toLocaleString('nl-NL', {minimumFractionDigits: 2, maximumFractionDigits: 2});
	}
}

export default PriceCalculator;
